import React from "react";
import { motion } from "framer-motion";
import { fadeUp, stagger } from "../../lib/motion";

const pains = ["Disorganised", "Inconsistent", "Harder than they should be"];

export default function Problem() {
  return (
    <section data-testid="problem-section" className="py-28 sm:py-40 bg-[color:var(--bg-alt)]">
      <div className="max-w-5xl mx-auto px-6 sm:px-8">
        <motion.div {...fadeUp} className="max-w-3xl">
          <p className="overline mb-8">— The Truth</p>
          <p className="font-serif-display text-4xl sm:text-5xl lg:text-6xl leading-[1.08] tracking-tight text-[color:var(--charcoal)] font-medium">
            You don't need more information.
            <br />
            <span className="text-[color:var(--text-secondary)]">You don't need another course.</span>
          </p>
          <div className="my-10 w-12 h-px bg-[color:var(--gold)]" />
          <p className="font-serif-display italic text-2xl sm:text-3xl text-[color:var(--charcoal)]">
            You need your business <span className="text-[color:var(--gold)]">set up properly</span>.
          </p>
        </motion.div>

        <motion.div {...fadeUp} className="mt-20 grid grid-cols-1 lg:grid-cols-12 gap-12">
          <p className="lg:col-span-4 text-lg text-[color:var(--text-secondary)] leading-relaxed">
            Without the right structure behind the scenes, things feel:
          </p>
          <motion.ul
            {...stagger}
            className="lg:col-span-8 space-y-0"
            data-testid="problem-list"
          >
            {pains.map((p, i) => (
              <motion.li
                key={p}
                {...fadeUp}
                className="flex items-baseline gap-6 border-t border-[color:var(--border-light)] py-6 last:border-b"
                data-testid={`problem-item-${i}`}
              >
                <span className="font-serif-display italic text-xl text-[color:var(--gold)]">
                  0{i + 1}
                </span>
                <h3 className="font-serif-display text-2xl sm:text-3xl text-[color:var(--charcoal)] font-medium">
                  {p}
                </h3>
              </motion.li>
            ))}
          </motion.ul>
        </motion.div>

        <motion.p
          {...fadeUp}
          className="mt-20 font-serif-display italic text-2xl sm:text-3xl text-[color:var(--charcoal)] max-w-2xl"
        >
          This is where everything changes.
        </motion.p>
      </div>
    </section>
  );
}
